import { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowReconnected(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline && !showReconnected) return null;

  return (
    <div className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
      isOnline ? 'bg-emerald-500' : 'bg-red-500'
    }`}>
      <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-2 text-white text-sm">
        {isOnline ? (
          <>
            <Wifi className="w-4 h-4" />
            <span>تم استعادة الاتصال</span>
          </>
        ) : (
          <>
            <WifiOff className="w-4 h-4 animate-pulse" />
            <span>لا يوجد اتصال بالإنترنت - البيانات المخزنة مؤقتاً قد تكون قديمة</span>
          </>
        )}
      </div>
    </div>
  );
};

export default OfflineIndicator;
